/**
 * DevExtreme (esm/localization/default_date_names.js)
 * Version: 22.2.5
 * Build date: Mon Mar 27 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    map
} from "../core/utils/iterator";
var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var PERIODS = ["AM", "PM"];
var QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

// DBS Start
// T12239 SS 20230725
// Adding functionality to allow translating the default month, day, period and quarter names.
// These are not a part of the standard messages dictionary, hence the need to do this here instead.
// Note: This also requires disabling Intl via disableIntl(), otherwise all date strings are translated
// internally, which we do not want.
function translateArray(arr, _t) {
	for (let i = 0; i < arr.length; i++){
		arr[i] = _t(arr[i]);
	}
}

window.SB_DEVEX_loadDateMessages = function(_t) {
	translateArray(MONTHS, _t);
	translateArray(DAYS, _t);
	translateArray(PERIODS, _t);
	translateArray(QUARTERS, _t);
}	
// DBS Finish

var cutCaptions = (captions, format) => {
    var lengthByFormat = {
        abbreviated: 3,
        short: 2,
        narrow: 1
    };
    return map(captions, caption => caption.substr(0, lengthByFormat[format]))
};
export default {
    getMonthNames: function(format) {
        return cutCaptions(MONTHS, format)
    },
    getDayNames: function(format) {
        return cutCaptions(DAYS, format)
    },
    getQuarterNames: function(format) {
        return QUARTERS
    },
    getPeriodNames: function(format) {
        return PERIODS
    }
};
